const icon = (body: string) =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${body}</svg>`

export const NAV_ICONS = {
  solid: icon('<circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="2.5" fill="currentColor" stroke="none"/>'),
  gradient: icon('<circle cx="12" cy="12" r="7"/><path d="M12 5a7 7 0 0 1 0 14Z" fill="currentColor" stroke="none" opacity=".75"/>'),
  grid: icon('<path d="M5 8h14M5 16h14M8 5v14M16 5v14"/>'),
  uniformity: icon('<circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="3" opacity=".55"/>'),
  burnIn: icon('<path d="M18.2 8A7 7 0 1 0 19 14"/><path d="M18 4v4h-4"/>'),
  refresh: icon('<path d="M18.2 8A7 7 0 1 0 19 14"/><path d="M18 4v4h-4"/><path d="M9 12h3V8"/>'),
  motion: icon('<path d="M4 8h8M3 12h11M5 16h7"/><path d="m14 8 4 4-4 4"/>'),
  touch: icon('<circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/>'),
  media: icon('<rect x="4" y="5" width="16" height="14" rx="3"/><path d="m8 15 2.5-3 2 2 2.5-3 2 4"/><circle cx="9" cy="9" r="1"/>'),
  safeArea: icon('<path d="M9 5H5v4M15 5h4v4M9 19H5v-4M15 19h4v-4"/>'),
  report: icon('<path d="M7 3h8l4 4v14H7z"/><path d="M15 3v5h4M10 12h6M10 16h6"/>'),
  inspect: icon('<path d="M5 12.5 9.5 17 19 7"/><path d="M5 6h7M5 20h14"/>'),
  settings: icon('<circle cx="12" cy="12" r="3"/><path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.4-2.4 1A8 8 0 0 0 15 6l-.3-2.6h-4L10.4 6A8 8 0 0 0 9 7.1l-2.4-1-2 3.4 2 1.5a7 7 0 0 0 0 2l-2 1.5 2 3.4 2.4-1A8 8 0 0 0 10.5 18l.3 2.6h4L15 18a8 8 0 0 0 1.5-1.1l2.4 1 2-3.4-2-1.5a7 7 0 0 0 .1-1Z"/>'),
  question: icon('<circle cx="12" cy="12" r="8"/><path d="M9.8 9a2.4 2.4 0 1 1 3.3 2.2c-.8.4-1.1.9-1.1 1.8M12 16.5h.01"/>'),
  article: icon('<path d="M6 4h12v16H6z"/><path d="M9 8h6M9 12h6M9 16h4"/>'),
} as const

export const NAV = {
  quality: [
    { id: 'solid-color', href: '/solid-color.html', key: 'solid', icon: NAV_ICONS.solid },
    { id: 'gradient', href: '/gradient.html', key: 'gradient', icon: NAV_ICONS.gradient },
    { id: 'grid', href: '/grid.html', key: 'grid', icon: NAV_ICONS.grid },
    { id: 'uniformity', href: '/uniformity.html', key: 'uniformity', icon: NAV_ICONS.uniformity },
    { id: 'anti-burn-in', href: '/anti-burn-in.html', key: 'anti_burn_in', icon: NAV_ICONS.burnIn },
  ],
  motion: [
    { id: 'refresh-rate', href: '/refresh-rate.html', key: 'refresh', icon: NAV_ICONS.refresh },
    { id: 'motion', href: '/motion.html', key: 'motion_tool', icon: NAV_ICONS.motion },
  ],
  touch: [{ id: 'touch', href: '/touch.html', key: 'touch_tool', icon: NAV_ICONS.touch }],
  lab: [
    { id: 'media-lab', href: '/media-lab.html', key: 'media_lab', icon: NAV_ICONS.media },
    { id: 'safe-area', href: '/safe-area.html', key: 'safe_area', icon: NAV_ICONS.safeArea },
    { id: 'report', href: '/report.html', key: 'nav_report', icon: NAV_ICONS.report },
    { id: 'inspect', href: '/inspect.html', key: 'nav_inspect', icon: NAV_ICONS.inspect },
    { id: 'settings', href: '/settings.html', key: 'nav_settings', icon: NAV_ICONS.settings },
  ],
} as const
